module.exports = __webpack_public_path__ + "static/media/cplusplus.18ae83b0.svg";